import * as React from 'react';
import {IOption, IOptionGroup} from "../../classes/seating-option";

interface IRadioProps{
    key: string;
    onChangeFunction: (IOption, IOptionGroup) => any;
    checked: boolean;

    option: IOption;
    optionGroup: IOptionGroup;
    disabled: boolean;
}

class Radio extends React.Component<IRadioProps, any> {
    render() {
        return (
            <li className="form-item">
                <input type="radio" disabled={this.props.disabled} name={this.props.optionGroup.name} value={this.props.option.name} id={this.props.option.id}
                    onClick={() => { this.props.onChangeFunction(this.props.option, this.props.optionGroup) } }
                    checked={this.props.checked}/>
                <label htmlFor={this.props.option.id}>{this.props.option.name}</label>
            </li>
        );
    }
}

export default Radio;